module.exports = __webpack_public_path__ + "static/fail-modal-icon.65fa6c1c.png";